/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';

const ExternalLink = ({ className, href, target, child }) => (
  <div role="presentation" className={className}>
    <a
      href={href}
      target={target}
      rel="noopener noreferrer"
    >
      {child}
    </a>
  </div>
);
ExternalLink.propTypes = {
  child: PropTypes.any,
  href: PropTypes.string.isRequired,
  target: PropTypes.string.isRequired,
  className: PropTypes.string,
};
ExternalLink.defaultProps = {
  child: undefined,
  className: '',
};
export default ExternalLink;
